import './ConsoleErrorsSection.less';
import React from 'react';
import SectionCompetitorResults from '../../shared/SectionCompetitorResults';
import SectionMessage from '../../shared/SectionMessage';
import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import { SectionProps } from '../../types';
import InlineModal from '../../shared/InlineModal';
import HowToFix from '../../shared/HowToFix';

function getConsoleMessage(text: string) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, (result) => {
        const url = result.length > 80 ? `${result.slice(0, 39)}...${result.slice(-38)}` : result;
        return `<a href="${result}" rel="noopener noreferrer">${url}</a>`;
    });
}

export default function ConsoleErrorsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {['warning', 'failed'].includes(result.status) && (
                    <>
                        <div className="description-meta">
                            <InlineModal
                                openLabel="See results list"
                                modalTitle="Full list of console messages"
                                closeLabel="Close"
                            >
                                {result.errors.length > 0 && (
                                    <ConsoleMessageList
                                        title="Errors"
                                        consoleMessages={result.errors}
                                    />
                                )}

                                {result.warnings.length > 0 && (
                                    <ConsoleMessageList
                                        title="Warnings"
                                        consoleMessages={result.warnings}
                                    />
                                )}
                            </InlineModal>
                        </div>

                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type ConsoleMessageListProps = {
    title: string;
    consoleMessages: {
        level: string;
        source: string;
        text: string;
        url: string;
        line_number: number;
        column_number: number;
    }[];
};

function ConsoleMessageList({ title, consoleMessages }: ConsoleMessageListProps) {
    return (
        <div className="console-message-list">
            {title && (
                <h3>
                    {title}({consoleMessages.length}):
                </h3>
            )}

            <ul>
                {consoleMessages.map((item, index) => (
                    <li
                        className="console-message"
                        key={index}
                    >
                        <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {item.url}
                        </a>
                        <code>
                            <div dangerouslySetInnerHTML={{ __html: getConsoleMessage(item.text) }} />
                        </code>
                    </li>
                ))}
            </ul>
        </div>
    );
}
